<template>
  <div>
    <div class="appui">
      <div class="appui-head">
        <div>
          <h1 class="appui-title">Menu do App</h1>
          <div class="appui-crumb">App <span class="sep">/</span> Menu</div>
        </div>
      </div>

      <!-- Vazio -->
      <div v-if="!menu.length" class="appui-emptystate">
        <div class="appui-emptystate-icon"><i class="bx bx-menu"></i></div>
        <div class="appui-emptystate-title">Menu vazio</div>
        <div class="appui-emptystate-sub">Monte o menu que o participante vê no app — até 2 níveis, apontando para telas internas ou links externos.</div>
        <button class="appui-btn appui-btn--primary" @click="openCreate(null)">+ Adicionar o primeiro item</button>
      </div>

      <!-- Bloco principal -->
      <section v-else class="appui-card appui-card--flush">
        <div class="appui-card-toolbar">
          <div class="appui-card-toolbar-left">
            <span class="appui-toolbar-hint"><i class="mdi mdi-drag-vertical"></i> Arraste para reordenar — até 2 níveis. Itens de módulo não podem ser excluídos.</span>
          </div>
          <div class="appui-card-toolbar-right">
            <button class="appui-btn appui-btn--primary" @click="openCreate(null)">+ Novo item</button>
          </div>
        </div>

        <draggable
          :list="menu"
          :element="'div'"
          style="padding:14px 16px;display:flex;flex-direction:column;gap:8px"
          :options="{ animation: 180, handle: '.appui-grip', ghostClass: 'appui-drag-ghost' }"
          @end="persistOrder(menu)"
        >
          <div v-for="item in menu" :key="item.id">
            <div class="appui-menu-row">
              <span class="appui-grip" title="Arraste para reordenar">⠿</span>
              <span class="appui-icon-chip"><i :class="item.icon || 'mdi mdi-link-variant'"></i></span>
              <span style="font-weight:500;font-size:13px;color:#495057;flex:1;min-width:0">{{ item.name }}</span>
              <span class="appui-badge" :class="item.module ? 'appui-badge--blue' : ''" :title="item.module || item.link">{{ destLabel(item) }}</span>
              <button class="appui-switch" :class="{ 'is-on': item.status }" title="Visível no app" @click="toggle(item)"><span class="knob"></span></button>
              <span style="white-space:nowrap">
                <button class="appui-tbtn" style="margin-right:6px" title="Adicionar subitem" @click="openCreate(item.id)">+ Sub</button>
                <button class="appui-tbtn" style="margin-right:6px" @click="openEdit(item)">Editar</button>
                <button v-if="!item.module" class="appui-tbtn appui-tbtn--danger" @click="remove(item)">Excluir</button>
              </span>
            </div>

            <!-- Subitens (nível 2) -->
            <draggable
              v-if="item.children && item.children.length"
              :list="item.children"
              :element="'div'"
              class="appui-menu-children"
              :options="{ animation: 180, handle: '.appui-grip', ghostClass: 'appui-drag-ghost' }"
              @end="persistOrder(item.children)"
            >
              <div v-for="child in item.children" :key="child.id" class="appui-menu-row appui-menu-row--child">
                <span class="appui-grip" title="Arraste para reordenar">⠿</span>
                <i class="mdi mdi-subdirectory-arrow-right" style="color:#ced4da"></i>
                <span class="appui-icon-chip" style="width:26px;height:26px;font-size:13px"><i :class="child.icon || 'mdi mdi-link-variant'"></i></span>
                <span style="font-size:12.5px;color:#495057;flex:1;min-width:0">{{ child.name }}</span>
                <span class="appui-badge" :class="child.module ? 'appui-badge--blue' : ''" :title="child.module || child.link">{{ destLabel(child) }}</span>
                <button class="appui-switch" :class="{ 'is-on': child.status }" title="Visível no app" @click="toggle(child)"><span class="knob"></span></button>
                <span style="white-space:nowrap">
                  <button class="appui-tbtn" style="margin-right:6px" @click="openEdit(child)">Editar</button>
                  <button v-if="!child.module" class="appui-tbtn appui-tbtn--danger" @click="remove(child)">Excluir</button>
                </span>
              </div>
            </draggable>
          </div>
        </draggable>
      </section>
    </div>

    <b-modal v-model="showModal" :title="modalTitle" hide-footer>
      <form @submit.prevent="save()">
        <div class="form-group">
          <label>Título *</label>
          <input type="text" class="form-control" v-model="form.name" required>
        </div>
        <div class="form-group">
          <label>Módulo (tela interna)</label>
          <input type="text" class="form-control" v-model="form.module" :disabled="isModuleItem" placeholder="ex: schedule, speakers, sponsors">
          <small v-if="isModuleItem" class="text-muted">Item de módulo do sistema — o destino não pode ser alterado.</small>
          <small v-else class="text-muted">Preencha módulo OU link externo.</small>
        </div>
        <div class="form-group">
          <label>Link externo</label>
          <input type="url" class="form-control" v-model="form.link" :disabled="isModuleItem" placeholder="https://...">
        </div>
        <div class="form-group">
          <label>Ícone</label>
          <input type="text" class="form-control" v-model="form.icon" placeholder="ex: mdi mdi-calendar">
        </div>
        <div class="text-right">
          <button type="button" class="btn btn-light mr-2" @click="showModal = false">Cancelar</button>
          <button type="submit" class="btn btn-primary" :disabled="saving">Salvar</button>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import services from './services'
import './app-ui.css'

export default {
  components: { draggable },
  name: 'app-menu',
  data () {
    return {
      menu: [],
      showModal: false,
      saving: false,
      isModuleItem: false,
      form: { id: null, name: '', module: '', link: '', icon: '', ref_id: null }
    }
  },
  computed: {
    modalTitle () {
      if (this.form.id) return 'Editar item'
      return this.form.ref_id ? 'Novo subitem' : 'Novo item'
    }
  },
  mounted () { this.load() },
  methods: {
    load () {
      const loader = this.$loading.show()
      services.listMenu()
        .then(res => { this.menu = res.data.data })
        .catch(() => errorMessage('Falha ao carregar menu.', 3000))
        .finally(() => loader.hide())
    },
    destLabel (item) {
      if (item.module) return item.module
      if (item.link) return 'link externo'
      return '—'
    },
    openCreate (refId) {
      this.isModuleItem = false
      this.form = { id: null, name: '', module: '', link: '', icon: '', ref_id: refId }
      this.showModal = true
    },
    openEdit (item) {
      this.isModuleItem = !!item.module
      this.form = { id: item.id, name: item.name, module: item.module, link: item.link, icon: item.icon, ref_id: item.ref_id }
      this.showModal = true
    },
    async save () {
      this.saving = true
      try {
        const payload = { name: this.form.name, module: this.form.module || null, link: this.form.link || null, icon: this.form.icon || null, ref_id: this.form.ref_id || null }
        if (this.form.id) await services.updateMenu(this.form.id, payload)
        else await services.createMenu(payload)
        this.showModal = false
        successMessage('Item salvo.', 2000)
        this.load()
      } catch (e) { errorMessage('Falha ao salvar item.', 3000) } finally { this.saving = false }
    },
    async toggle (item) {
      try { await services.changeMenuStatus(item.id); item.status = item.status ? 0 : 1 } catch (e) { errorMessage('Falha ao alterar status.', 3000) }
    },
    async remove (item) {
      const ok = await this.$bvModal.msgBoxConfirm('Remover este item (e seus subitens)?', { okTitle: 'Remover', cancelTitle: 'Cancelar', okVariant: 'danger' })
      if (!ok) return
      try { await services.deleteMenu(item.id); this.load() } catch (e) { errorMessage('Falha ao remover.', 3000) }
    },
    async persistOrder (list) {
      const itens = list.map((it, idx) => ({ id: it.id, sequence: idx + 1 }))
      try { await services.reorderMenu(itens) } catch (e) { errorMessage('Falha ao reordenar.', 3000); this.load() }
    }
  }
}
</script>
